<template>
	<div class="ListEditView">
		<slot name="add" :add="() => add()" :addAppend="() => add()" :addPrepend="() => addPrepend()" v-if="hasAdd">
			<span @click="add()">Add store</span>
		</slot>

		<sortable-list :lockAxis="lockAxis" :axis="axis" :value="value" @input="update" :useDragHandle="true"
			:distance="distance" :helperClass="helperClass" :shouldCancelStart="shouldCancelStart">

			<sortable-item v-for="(item, index) in valueList" :index="index" :key="item.id || item.cid || 'i' + index"
				:item="item" v-if="!item.removed">
				<slot :item="item" :index="index" :remove="() => remove(index)">
					{{ item }}
				</slot>
			</sortable-item>

			<slot name="add-inline" :add="() => add()" v-if="hasAddInline">
				<span @click="add()">Add Inline</span>
			</slot>

			<div class="ListEditViewErrors u-ErrorView" v-if="validationList && validationList.$error">
				<div class="error" v-if="validationList.required === false">
					<slot name="error-required" :error="validationList">List must not be empty.</slot>
				</div>
				<div class="error" v-if="validationList.minLength === false">
					<slot name="error-minLength" :error="validationList">
						List must have at least
						{{ validationList.$params.minLength.min }} elements.
					</slot>
				</div>
			</div>

		</sortable-list>
	</div>
</template>

<script>
import SortableList from "./ListEditViewList.vue";
import SortableItem from "./ListEditViewItem.vue";
import cloneDeep from "lodash/cloneDeep";

export default {
	name: "ListEditView",
	props: {
		value: { type: Array, default: () => [] },
		validationList: { type: Object, default: null },
		template: { type: Object, default: () => ({}) },
		hasAdd: { type: Boolean, default: false },
		hasAddInline: { type: Boolean, default: false },
		markRemoved: { type: Boolean, default: true },
		lockAxis: { type: String, default: "y" },
		axis: { type: String, default: "y" },
		prepend: { type: Boolean, default: false },
		distance: { type: Number, default: 0 },
		helperClass: { type: String, default: "helper" },
		shouldCancelStart: { type: Function, default: undefined },
		removePrompt: { type: String, default: "" },
		isCustomOrder: { type: Boolean, default: false },
		isSpecialistsOrder: { type: Boolean, default: false },
		parentId: { type: Number | String, default: null },
		reorderField: { type: String, default: "" },
	},
	data() {
		return {};
	},
	computed: {
		valueList() {
			if (this.validationList != null) {
				return (
					(this.validationList.$each &&
						this.validationList.$each.$iter &&
						Object.values(this.validationList.$each.$iter)) ||
					this.value
				);
			} else {
				return this.value;
			}
		},
	},
	components: {
		SortableItem,
		SortableList,
	},
	mounted() {
		if (this.validationList != null) {
			this.validationList.$touch();
		}
	},
	methods: {
		add(template) {
			this.appendItem(cloneDeep(template || this.template));
		},

		addPrepend(template) {
			this.appendItem(cloneDeep(template || this.template), true);
		},

		remove(ind) {
			if (this.removePrompt && !confirm(this.removePrompt)) {
				return;
			}
			let newVal = this.reorder(
				this.value.filter((v, i) => {
					return i !== ind;
				})
			);
			if (this.markRemoved) {
				newVal.push({ ...this.value[ind], removed: true });
			}
			this.update(newVal);
			this.$forceUpdate()
		},

		update(newVal) {
			if (this.isCustomOrder) {
				this.$emit("input", this.customReorder(newVal, this.parentId));
			} else if (this.isSpecialistsOrder) {
				console.log(newVal, this.parentId)
				this.$emit("input", this.localReorder(newVal, this.parentId));
			} else if (this.reorderField !== '') {
				this.$emit("input", this.reorderList(newVal, this.reorderField));
			}else {
				this.$emit("input", this.reorder(newVal));
			}

			if (this.validationList != null) {
				this.validationList.$touch();
			}
		},

		appendItem(item, prepend) {
			const _prepend =
				typeof prepend !== "undefined" ? prepend : this.prepend;
			if (_prepend) {
				this.update([item, ...this.value]);
			} else {
				this.update([...this.value, item]);
			}
		},
	},
};
</script>

<style lang="less">
@import "~styles/const.less";

@r: .ListEditView;

@{r} {
	margin: 0;
	position: relative;
	-moz-user-select: none;
	-khtml-user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
	user-select: none;

	input,
	textarea,
	[contenteditable] {

		&,
		& * {
			-moz-user-select: text;
			-khtml-user-select: text;
			-webkit-user-select: text;
			-ms-user-select: text;
			user-select: text;
		}
	}

	&Errors {
		display: none;
	}
}

@{r}ErrorsErrors .error {
	color: red;
}

.u-ShowErrors @{r}Errors {
	display: block;
}
</style>
